import Create from './Create';
import Edit from './Edit';

export default {
  create: Create,
  edit: Edit,
};
